<template>
  <div id="search" class="search-holder">
    <div v-show="showMenu"></div>
    <v-text-field
      v-model="query"
      flat
      solo-inverted
      hide-details
      clearable
      prepend-inner-icon="mdi-magnify"
      label="Recherche"
      transition="scale-transition"
      :append-icon="showMenu ? 'mdi-chevron-up' : 'mdi-chevron-down'"
      @keyup.enter="search()"
      @click:clear="clearSearch()"
      @click:append="showMenu = !showMenu"
    />
    <div id="adv-search"></div>
    <v-menu
      v-model="showMenu"
      attach="#adv-search"
      offset-y
      :close-on-content-click="false"
      absolute
      tile
      max-width="100%"
      min-width="100%"
      max-height="85vh"
    >
      <v-form ref="searchForm">
        <v-card tile>
          <v-card-title>Recherche avancées</v-card-title>
          <v-card-text class="pb-1">
            <v-row>
              <v-col
                v-for="(item, index) in fields"
                :key="index"
                class="d-flex align-center"
                :class="item.col"
              >
                <v-text-field
                  v-if="item.type == 'text' || item.type == 'number'"
                  v-model="item.value"
                  outlined
                  clearable
                  dense
                  hide-details
                  :label="item.label"
                  :placeholder="item.placeholder"
                />

                <div v-if="item.type == 'toggle'" class="d-flex">
                  <span class="mr-2">{{ item.label }}</span>
                  <div>
                    <v-switch v-model="item.value" hide-details />
                  </div>
                </div>

                <SearchDatePicker
                  v-if="item.type == 'date'"
                  v-model="item.value"
                  :field="item"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-4 pt-1 pb-4">
            <v-spacer />
            <v-btn
              class="px-6"
              elevation="0"
              @click="clearForm()"
            >
              effacer
            </v-btn>
            <v-btn
              color="error"
              class="px-6"
              elevation="0"
              @click="search(true)"
            >
              rechercher
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-menu>
  </div>
</template>

<script>
import { EventBus } from '../../mixins';
import SearchDatePicker from './SearchDTPicker';

export default {
  name: 'SearchBar',
  components: { SearchDatePicker },
  data () {
    return {
      query: this.$route.query.query,
      showMenu: false,
      fields: JSON.parse(
        JSON.stringify(this.$store.state.advancedFieldSearchConfig)
      )
    };
  },
  watch: {
    $route (to, from) {
      // When we go back if is the same component, we change the search
      this.query = this.$route.query.query || '';
    }
  },
  mounted () {
    EventBus.$on('showAdvancedSearch', this.showAdvancedSearch);
  },
  beforeDestroy () {
    EventBus.$off('showAdvancedSearch');
  },
  created () {
    // UPDATES ADVANCED SEARCH VALUES
    Object.entries(this.$route.query).forEach(([key, value]) => {
      const field = this.fields.find(field => field.field_name === key);
      if (field) {
        field.value = value;
      }
    });
  },
  methods: {
    clearSearch () {
      this.$router.push({ name: 'Home' }).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          throw error;
        }
      });
    },
    clearForm () {
      if (this.$refs.searchForm) {
        this.$refs.searchForm.reset();
      }
    },
    search (advanced = false) {
      const queryParams = {};

      // If is advanced search adds params
      if (advanced) {
        this.fields.forEach(field => {
          if (field.value && field.value !== '') {
            queryParams[field.field_name] = field.value;
          }
        });
        this.query = '';
      } else {
        this.clearForm();

        if (this.query !== '') {
          queryParams.query = this.query;
        }
      }

      this.$router.push({ name: 'Home', query: queryParams }).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          throw error;
        }
      });

      this.showMenu = false;
    },
    showAdvancedSearch: function () {
      this.showMenu = true;
    }
  }
};
</script>

<style lang="scss">
#adv-search {
  position: relative;
}
.search-holder {
  position: relative;
  width: 100%;
  max-width: 600px;
}
.overlay {
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  background-color: #00000080;
}
</style>
